var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFourSquares(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29289 2.29289C2 2.58579 2 3.05719 2 4V9C2 9.94281 2 10.4142 2.29289 10.7071C2.58579 11 3.05719 11 4 11H9C9.94281 11 10.4142 11 10.7071 10.7071C11 10.4142 11 9.94281 11 9V4C11 3.05719 11 2.58579 10.7071 2.29289C10.4142 2 9.94281 2 9 2H4C3.05719 2 2.58579 2 2.29289 2.29289Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2929 2.29289C13 2.58579 13 3.05719 13 4V9C13 9.94281 13 10.4142 13.2929 10.7071C13.5858 11 14.0572 11 15 11H20C20.9428 11 21.4142 11 21.7071 10.7071C22 10.4142 22 9.94281 22 9V4C22 3.05719 22 2.58579 21.7071 2.29289C21.4142 2 20.9428 2 20 2H15C14.0572 2 13.5858 2 13.2929 2.29289Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15C13 14.0572 13 13.5858 13.2929 13.2929C13.5858 13 14.0572 13 15 13H20C20.9428 13 21.4142 13 21.7071 13.2929C22 13.5858 22 14.0572 22 15V20C22 20.9428 22 21.4142 21.7071 21.7071C21.4142 22 20.9428 22 20 22H15C14.0572 22 13.5858 22 13.2929 21.7071C13 21.4142 13 20.9428 13 20V15Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29289 13.2929C2 13.5858 2 14.0572 2 15V20C2 20.9428 2 21.4142 2.29289 21.7071C2.58579 22 3.05719 22 4 22H9C9.94281 22 10.4142 22 10.7071 21.7071C11 21.4142 11 20.9428 11 20V15C11 14.0572 11 13.5858 10.7071 13.2929C10.4142 13 9.94281 13 9 13H4C3.05719 13 2.58579 13 2.29289 13.2929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourSquares);
export default __webpack_public_path__ + "static/media/four_squares.f71787217cee5f0556e8057ec757c496.svg";
export { ForwardRef as ReactComponent };